<template>
	<div class="userHead">
		
	</div>
</template>

<script>
	export default{
		
	}
</script>

<style scoped>
	.userHead{
		width: 100%;
		height: 50px;

	}
</style>